<template>
	<div class="groups-message-container" style="height:inherit">
		<a v-show="from === 'groups-modal'" :class="backStyle" @click="justGoBack">
			<ion-icon name="arrow-round-back"></ion-icon>
		</a>
		<a v-if="!showOptionsComponent" :class="optionsStyle" @click="handleOptions">
			<ion-icon name="information-circle-outline"></ion-icon>
		</a>
		<a v-else :class="optionsStyle" @click="handleOptions">
			<ion-icon name="information-circle"></ion-icon>
		</a>
		<div v-show="!showOptionsComponent" class="groups-message">
			<div v-if="!groupName && users" class="active-users">
				<user-images-list :users="users"></user-images-list>
			</div>
			<div v-else class="active-users">
				<h2 class="group-name">{{groupName}}</h2>
				<user-images-list :users="users"></user-images-list>
			</div>
			<message-display :messages="messages" :members="users"></message-display>
			<keep-alive>
				<message-controls :groupID="groupID"></message-controls>
			</keep-alive>
		</div>
		<div v-show="showOptionsComponent">
			<groups-message-options
				:users="users"
				:admin="admin"
				:groupName="groupName"
				:groupID="groupID"
				:dateCreated="dateCreated"
				@deleteGroup="deleteGroup"
				@leaveGroup="leaveGroup"
			></groups-message-options>
		</div>
	</div>
</template>

<script>
import { db } from "../../../resources/firebase";
import firebase from "firebase/app";
import GroupsMessageOptions from "./GroupsMessageOptions.vue";
import MessageDisplay from "./GroupsMessageDisplay.vue";
import MessageControls from "./GroupsMessageControls.vue";
import UserImagesList from "../../users/userLists/UserImagesList.vue";

export default {
	data() {
		return {
			showOptionsComponent: false,
			toStep: 1,
			messages: []
		};
	},
	props: {
		groupID: {
			type: String
		},
		users: {
			type: Array,
			required: true
		},
		groupName: {
			type: String
		},
		admin: {
			type: String
		},
		dateCreated: {
			type: Object
		},
		from: {
			type: String
		}
	},
	components: {
		GroupsMessageOptions,
		MessageDisplay,
		MessageControls,
		UserImagesList
	},
	beforeMount() {
		let groupModalTitle = window.document.querySelector(".modal-title span");

		if (this.from === "groups-modal") {
			groupModalTitle.style.marginLeft = "25px";
		} else {
			groupModalTitle.style.marginLeft = "0px";
		}

		let ref = db
			.collection("test_groups")
			.doc(this.groupID)
			.collection("messages")
			.orderBy("dateCreated");

		ref.onSnapshot({ includeMetadataChanges: true }, snapshot => {
			// let source = snapshot.metadata.hasPendingWrites ? 'Local' : 'Server'
			// console.log(snapshot.metadata.hasPendingWrites)
			snapshot.docChanges().forEach(change => {
				if (change.type === "added") {
					const authUser = this.$store.state.user.authUser.uid;
					const newMessage = change.doc.data();
					this.messages.push(newMessage);
					/**
					 * TO DO:
					 * - Call browser's notifications API
					 */
					// if (authUser !== newMessage.senderID) {
					// 	if (Notification.permission === "granted") {
					// 		var notif = new Notification("New Message", {
					// 			body: newMessage.message,
					// 			icon: "../../../../static/android-chrome-192x192.png",
					// 			data: {
					// 				group: {
					// 					admin: this.admin,
					// 					// dateCreated: firebase.firestore.Timestamp.fromDate(
					// 					// 	this.dateCreated
					// 					// ),
					// 					dateCreated: this.dateCreated,
					// 					groupID: this.groupID,
					// 					groupName: this.groupName,
					// 					members: this.users.map(user => user.userID),
					// 					membersData: this.users
					// 				}
					// 			}
					// 		});
					// 		// console.log(
					// 		// 	firebase.firestore.Timestamp.fromDate(this.dateCreated)
					// 		// );
					// 		notif.onclick = event => {
					// 			event.preventDefault();
					// 			console.log(event);
					// 			const payload = {
					// 				show: true,
					// 				from: "groups",
					// 				group: event.target.data.group
					// 			};

					// 			//Set state
					// 			this.$store.commit("updateGroupsModal", payload);

					// 			//Modal open effect
					// 			const html = document.querySelector("html");
					// 			const app = document.querySelector("#app");
					// 			app.classList.add("blur-app");
					// 			html.style.overflowY = "hidden";
					// 		};
					// 	} else if (
					// 		Notification.permission === "denied" ||
					// 		Notification.permission === "default"
					// 	) {
					// 		questPermission(permission => {
					// 			if (permission === "granted") {
					// 				var notif = new Notification("New Message", {
					// 					body: newMessage.message,
					// 					icon: "../../../../static/android-chrome-192x192.png"
					// 				});

					// 				notif.onclick = event => {
					// 					event.preventDefault();
					// 					console.log(event);
					// 				};
					// 			}
					// 		});
					// 	}
					// }
				}
			});
		});
	},
	beforeDestroy() {
		let unsubscribe = db
			.collection("test_groups")
			.doc(this.groupID)
			.collection("messages")
			.orderBy("dateCreated")
			.onSnapshot(snapshot => {});

		unsubscribe();
	},
	computed: {
		backStyle() {
			if (this.from === "groups-modal") {
				return {
					"back-button-new": false,
					"back-button-existing": true
				};
			} else {
				return {
					"back-button-new": true,
					"back-button-existing": false
				};
			}
		},
		optionsStyle() {
			if (this.from === "groups-modal") {
				return {
					"options-button-new": false,
					"options-button-existing": true
				};
			} else {
				return {
					"options-button-new": true,
					"options-button-existing": false
				};
			}
		}
	},
	methods: {
		handleBack(actionType = "", groupId = null) {
			let groupModalTitle = window.document.querySelector(".modal-title span");
			groupModalTitle.style.marginLeft = "0";
			if (actionType === "delete") {
				this.$emit("goBack", {
					actionType: actionType,
					groupID: groupId
				});
			} else if (actionType === "leave") {
				this.$emit("goBack", {
					actionType: actionType,
					groupID: groupId
				});
			} else {
				this.$emit("goBack", {
					actionType: "",
					groupID: null
				});
			}

			this.showOptionsComponent = false;
		},
		handleOptions() {
			this.showOptionsComponent = this.showOptionsComponent ? false : true;
		},
		justGoBack() {
			this.handleBack();
		},
		deleteGroup() {
			this.handleBack("delete", this.groupID);
		},
		leaveGroup() {
			this.handleBack("leave", this.groupID);
		}
	}
};
</script>

<style scoped>
.back-button-new {
	position: absolute;
	top: -45px;
	left: 0;
}

.back-button-existing {
	position: absolute;
	top: 20px;
	left: 20px;
}

.options-button-new {
	position: absolute;
	top: -45px;
	left: 82px;
}
.options-button-existing {
	position: absolute;
	top: 20px;
	left: 127px;
}

.groups-message {
	height: 100%;
	position: relative;
}

.active-users {
	padding-bottom: 10px;
	border-bottom: 1px solid #111;
	text-align: center;
}

.group-name {
	font-weight: bold;
	padding-bottom: 5px;
}

.user-deleted {
	opacity: 0.3;
}

ion-icon {
	color: #51c715;
	font-size: 20px;
	vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/groups/groupsMessage/GroupsMessage.vue